import api from '@/api'

export default {
  namespaced: true,

  state: () => ({
    data: null
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/settings`, params)

      ctx.commit('set', response)
    }
  },

  mutations: {
    set: function (state, taxInformation) {
      state.data = taxInformation
    },
    reset: function (state) {
      state.data = null
    }
  }
}
